import { required, size } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
import { mapGetters } from 'vuex'
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
})

const valueProposition = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        ruleMaxCaracters: [
            v => !!v || 'Este campo es obligatorio',
            v => v.length <= 250 || 'Max 250 caracteres'
        ],
        addProposition: false,
        form: {
            nombrePropuesta: '',
            descripcionPropuesta: '',
            indicadoresRelacionados: '',
            statusPropuesta: '',
            adjunto: null,
            centro: '',
            campana: '',
            clientes: '',
            creado_por: '',
        },
        updateProposition: {
            status: '',
            comments: '',
            id: ''
        },
        clients: [],
        context: 'creacion', // Contexto para crear propuesta
        indicadores: [],
        loading: false,
        loadingUpdt: false,
        loadingTbl: false,
        dialog: false,
        selectedPropuesta: {},
        RolUser: '',
        headerDetalle: [
            { text: 'Nombre de propuesta', value: 'nombre_propuesta', align: 'start', sortable: false },
            { text: 'Responsable', value: 'nombre_responsable', align: 'start', sortable: false },
            { text: 'Indicadores(kpi)', value: 'descripciones_indicadores', align: 'start', sortable: false, width: '300px' },
            { text: 'Estado', value: 'status_propuesta', align: 'start', sortable: false },
            { text: 'Descripción', value: 'descripcion_propuesta', align: 'start', sortable: false, width: '400px' },
            { text: 'Último archivo', value: 'acciones', align: 'start', sortable: false },
        ],
        propositionDialog: false,
        headers: [
            { text: 'Nombre de propuesta', value: 'nombre_propuesta', align: 'start', sortable: false },
            { text: 'Responsable', value: 'nombre_responsable', align: 'start', sortable: false },
            { text: 'Descripción', value: 'descripcion_propuesta', align: 'start', sortable: false },
            { text: 'Indicadores(kpi)', value: 'descripciones_indicadores', align: 'start', sortable: false },
            { text: 'Estado', value: 'status_propuesta', align: 'start', sortable: false },
            { text: 'Fecha de creacion', value: 'fecha_creacion', align: 'start', sortable: false },
            { text: 'Acciones', value: 'action', align: 'start', sortable: false },
        ],
        addPropuesta: {},
        editedPropuesta: {},
        newComment: '',
        items: [],

        loadingEdit: false,
        statusOptions: [
            { text: 'Expuesto', value: 'expuesto' },
            { text: 'Aprobado', value: 'aprobado' },
            { text: 'Rechazado por Revisión', value: 'rechazado_revision' },
            { text: 'Rechazado', value: 'rechazado' },
            { text: 'Detenido', value: 'detenido' }
        ],
    }),
    mounted() {
        this.fetchProposition();
        this.fetchClients();
        this.fetchIndicator();
        //this.form.creado_por = this.creatorId;
        this.RolUser = this.Rol;
    },
    computed: {
        ...mapGetters(['getPaises', 'getCentros', 'getCampanas', 'getCentrosAsignados', 'getCampanasAsignadas']),
        filteredCentros() {
            return this.getCentros.filter(centro => this.getCentrosAsignados.includes(centro.Id.toString())).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredCampanas() {
            if (!this.form.centro) {
                return []; // No se ha seleccionado ningún centro 
            }
            var lista = this.getCampanas.filter(campana =>
                campana.in_CentroId === this.form.centro &&
                this.getCampanasAsignadas.includes(campana.Id.toString())
            );

            return lista.sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion))
        },
        filteredClients() {
            if (!this.form.campana) {
                return []; // No se ha seleccionado ninguna campaña 
            } // Filtrar clientes por campaña seleccionada 
            return this.clients.filter(client =>
                client.campanas.some(campana => campana.in_CampanaId === this.form.campana)
            );
        },
        filteredStatusOptions() {
            if (this.context === 'creacion') {
                return this.statusOptions.filter(option => option.value === 'expuesto');
            } else if (this.$store.state.rol == '39') {
                return this.statusOptions.filter(option => option.value !== 'expuesto');
            } else {
                return this.statusOptions.filter(option => option.value === 'expuesto' || option.value === 'detenido');
            }
        },
        clientsWithFullName() {
            var lista = this.filteredClients.map(client => {
                return {
                    ...client,
                    fullName: `${client.vc_Nombres} ${client.vc_ApePaterno} ${client.vc_ApeMaterno}`
                };
            });

            return lista.sort((a, b) => a.fullName.localeCompare(b.fullName));
        },
        creatorId() {
            return this.$store.state.id;
        },
        Rol() {
            return this.$store.state.rol;
        },
        isCreator() {
            const creatorId = Number(this.$store.state.id);
            const revisionId = Number(this.selectedPropuesta.revision);
            return creatorId === revisionId;
        }
    },
    methods: {
        getStatusText(value) {
            const option = this.statusOptions.find(option => option.value === value);
            return option ? option.text : value;
        },
        getStatusColorTimeLine(estado) {
            switch (estado) {
                case 'expuesto':
                    return '#75c2ff';
                case 'aprobado':
                    return '#74cd77';
                case 'rechazado_revision':
                    return '#f3b860';
                case 'rechazado':
                    return '#ed7f76';
                case 'detenido':
                    return 'grey';
                default:
                    return 'grey';
            }
        },
        getStatusColor(estado) {
            switch (estado) {
                case 'expuesto':
                    return 'blue';
                case 'aprobado':
                    return 'green';
                case 'rechazado_revision':
                    return 'orange';
                case 'rechazado':
                    return 'red';
                case 'detenido':
                    return 'grey';
                default:
                    return 'grey';
            }
        },
        async fetchClients() {
            try {
                const response = await this.$axios.get('getClients');
                this.clients = response.data.all;
            } catch (error) {
                console.error('Error al obtener los clientes:', error);
            } finally {
                this.loadingTbl = false;
            }
        },
        async fetchIndicator() {
            try {
                const response = await this.$axios.get('getIndicator');
                this.indicadores = response.data.sort((a, b) => a.vc_nombre.localeCompare(b.vc_nombre));
            } catch (error) {
                console.error('Error al obtener los clientes:', error);
            }
        },
        async submitForm(reset) {
            this.loading = true;
            if( this.form.descripcionPropuesta.length > 250){
                this.$toast.error('El maximo de caracteres en el campo descripcion es 250');
                this.loading = false;
                return false;
            }
            try {
                const formData = new FormData();
                formData.append('nombrePropuesta', this.form.nombrePropuesta);
                formData.append('descripcionPropuesta', this.form.descripcionPropuesta);
                formData.append('indicadoresRelacionados', JSON.stringify(this.form.indicadoresRelacionados));
                formData.append('statusPropuesta', this.form.statusPropuesta);
                formData.append('adjunto', this.form.adjunto);
                formData.append('centro', this.form.centro);
                formData.append('campana', this.form.campana);
                formData.append('clientes', JSON.stringify(this.form.clientes));
                formData.append('creado_por', this.$store.state.id);

                const response = await this.$axios.post('newProposition', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.$toast.success('Propuesta agregado con exito');
                this.$refs.datos.reset();
                reset();
                this.closeForm();
                this.fetchProposition();
            } catch (error) {
                this.$toast.error('Hubo un error al guardar la propuesta');
                //console.error('Error al enviar los datos:', error);
            } finally {
                this.loading = false;
            }

        },
        verDocumento(filePath) {
            window.open(filePath, '_blank');
        },
        select(item) {
            this.editedPropuesta = { ...item };
            this.newComment = '';
            this.propositionDialog = true
        },
        viewDetails(item) {
            this.selectedPropuesta = { ...item };
            this.updateProposition.id = item.id;
            this.context = 'edicion'; // Cambiar el contexto a "edición"
            this.dialog = true;
        },
        async saveChanges(reset) {
            this.loadingUpdt = true;
            const formData = new FormData();
            formData.append('propuesta_id', this.updateProposition.id);
            formData.append('estado', this.updateProposition.status);
            formData.append('comentario', this.updateProposition.comments);
            formData.append('responsable_cambio', this.creatorId);

            if (this.updateProposition.file) {
                formData.append('adjunto', this.updateProposition.file);
            }

            try {
                const response = await this.$axios.post('newStatusComments', formData);
                this.cancel();
                this.fetchProposition();
                this.$toast.success('Cambios en la propuesta guardados con exito');
            } catch (error) {
                this.$toast.error('Hubo un problema al guardar los cambios');
            } finally {
                this.context = 'creacion'
                this.loadingUpdt = false;
            }
        },
        limpiar() {
            this.form = {
                nombrePropuesta: '',
                descripcionPropuesta: '',
                indicadoresRelacionados: '',
                statusPropuesta: '',
                adjunto: null,
                centro: '',
                campana: '',
                clientes: '',
                creado_por: '',
            }
        },
        limpiarActualizacion() {
            this.updateProposition = {
                status: '',
                comments: '',
                id: ''
            }
            this.context = 'creacion'
        },
        closeForm() {
            this.$refs.datos.reset();
            this.limpiar();
            this.addProposition = false;
        },
        cancel() {
            this.$refs.datosUpdate.reset();
            this.limpiarActualizacion();
            this.dialog = false;
        },
        async fetchProposition() {
            this.loadingTbl = true; // Iniciar carga
            try {
                const response = await this.$axios.get('propositions', {
                    params: {
                        creatorId: this.creatorId,
                        rol: this.Rol
                    }
                });
                this.items = response.data;
            } catch (error) {
                console.error('Error fetching propositions:', error);
                this.$toast.error('Hubo un error al cargar las propuestas')
            } finally {
                this.loadingTbl = false; // Finalizar carga
            }
        }
    }
}
export default valueProposition